import React from 'react';
import { useLocale } from '../../i18n/LocaleContext';
import { classNames } from '../../utils/format';

export default function LanguageToggle({ compact = false }) {
  const { locale, setLocale, availableLocales } = useLocale();
  return (
    <div className={classNames('lang-toggle', compact && 'lang-toggle--compact')} role="group" aria-label="Language">
      {availableLocales.map((code) => (
        <button
          key={code}
          type="button"
          className={classNames('lang-toggle__btn', locale === code && 'is-active')}
          onClick={() => setLocale(code)}
        >
          {code.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
